export const BAC_SPECIALTIES_QUERY_STRING = 'bs';
export const GENDER_QUERY_STRING = 'g';
export const HIGH_SCHOOL_CLASS_QUERY_STRING = 'hsc';
export const HIGH_SCHOOL_TYPE_QUERY_STRING = 'hst';
export const STATUS_QUERY_STRING = 's';
